//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import { defineComponent } from '../utils/create';
import { props } from './props';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "reward-wrapper"
  }, [_c('swiper', _vm._g(_vm._b({
    staticClass: "swiper-container",
    attrs: {
      "options": _vm.swiperOption
    }
  }, 'swiper', _vm.$attrs, false), _vm.$listeners), _vm._l(_vm.rewards, function (award, awardIndex) {
    return _c('swiper-slide', {
      key: 'award-' + awardIndex
    }, [_c('div', {
      staticClass: "award-item"
    }, [_vm._t("title", function () {
      return [_c('span', {
        staticClass: "award-item__title"
      }, [_vm._v(" " + _vm._s(_vm.rewardTitle) + "·TOP" + _vm._s(awardIndex + 1) + " ")])];
    }, {
      "index": awardIndex
    }), _vm._v(" "), _vm._l(award, function (subItem, subIdx) {
      return _c('div', {
        key: awardIndex + '-' + subIdx,
        staticClass: "award-item__content"
      }, [subItem[_vm.mergedGetter.tag] ? _c('img', {
        staticClass: "award-item__content-tag",
        attrs: {
          "src": subItem[_vm.mergedGetter.tag],
          "alt": "奖励标签"
        }
      }) : _vm._e(), _vm._v(" "), _vm._t("default", function () {
        return [_c('div', {
          staticClass: "award-item__content-wrapper"
        }, [_c('img', {
          staticClass: "award-item__content-img",
          attrs: {
            "src": subItem[_vm.mergedGetter.img]
          }
        })]), _vm._v(" "), subItem[_vm.mergedGetter.title] ? _c('span', {
          staticClass: "award-item__content-title"
        }, [_vm._v("\n              " + _vm._s(subItem[_vm.mergedGetter.title]) + "\n            ")]) : _vm._e(), _vm._v(" "), subItem[_vm.mergedGetter.value] ? _c('span', {
          staticClass: "award-item__content-score"
        }, [_vm._v("\n              " + _vm._s(subItem[_vm.mergedGetter.value] || '') + "\n            ")]) : _vm._e()];
      }, {
        "index": subIdx,
        "item": subItem
      })], 2);
    })], 2)]);
  }), 1)], 1);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-1007b8ce',
  render,
  name: 'CbRewardSwiper',
  components: {
    Swiper,
    SwiperSlide
  },
  props,
  data() {
    return {
      defaultGetter: {
        img: 'img',
        title: 'title',
        value: 'value',
        tag: 'tag'
      },
      swiperOption: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        loopFillGroupWithBlank: true,
        loop: true,
        coverflowEffect: {
          depth: 0,
          modifier: 1,
          rotate: 0,
          slideShadows: false
        }
      }
    };
  },
  computed: {
    mergedGetter() {
      return Object.assign(this.defaultGetter, this.fieldsGetter);
    }
  }
});